import React from 'react';
import { motion } from 'framer-motion';

const RefundPolicy = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const contactBlock = (
    <div className="bg-[#F9FFF5] border border-[#2E7D32]/20 p-6 rounded-lg mt-2">
      <p><strong>Sam's Nutri Hub</strong></p>
      <p>Venkatesh Prime, 4th Floor, Burudgaon Road</p>
      <p>Ahmednagar, Maharashtra 414001</p>
      <p>Email: <a href="mailto:hello@samsnutrihub.com" className="text-[#2E7D32] hover:underline">hello@samsnutrihub.com</a></p>
      <p>Phone: <a href="tel:+919637375555" className="text-[#2E7D32] hover:underline">+91 96373 75555</a></p>
    </div>
  );

  return (
    <div className="bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <motion.div {...fadeInUp}>
          <p className="text-sm text-[#9E9E9E] mb-2">Last updated: November 1, 2023</p>
          <h1 className="text-4xl font-bold text-[#0B1320] font-poppins mb-10">
            Refund Policy — Sam's Nutri Hub
          </h1>

          <div className="prose prose-lg max-w-none text-[#4A4A4A] leading-relaxed space-y-8">

            <section>
              <p>
                At Sam's Nutri Hub, we stand behind the quality of our consultations and programs. We want
                you to feel confident investing in your health journey with us. Please read this policy
                carefully before making a purchase.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">1. Money-Back Guarantee</h2>
              <p>
                We offer a <strong>money-back guarantee</strong> for a defined number of days after you
                purchase any consultation or program from us. The exact duration of the guarantee period
                will be communicated to you at the time of purchase and in your welcome documentation.
              </p>
              <p className="mt-4">
                This guarantee reflects our confidence in our protocols and our commitment to your success.
                We are only satisfied when you are.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">2. Conditions for Refund</h2>
              <p>
                A refund will <strong>not</strong> be granted if there is verifiable evidence that the client
                did not follow the prescribed program. Specifically, refunds will be declined if:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>The client deviated from or did not follow the given nutrition plan on any given day</li>
                <li>The client missed or skipped sessions outlined in the program</li>
                <li>The client did not adhere to the prescribed exercise schedule</li>
              </ul>
              <p className="mt-4">
                We track progress through check-ins and submitted logs. Honest participation is essential
                for results — and for eligibility under this guarantee.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">3. How to Apply for a Refund</h2>
              <p>
                To request a refund, you must contact our Customer Service team in writing within the
                guarantee period. Please include:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Your full name and registered email address</li>
                <li>The program or consultation you purchased</li>
                <li>A brief explanation of your experience and reason for the request</li>
                <li>Any relevant progress logs or documentation</li>
              </ul>
              <p className="mt-4">
                Our team will review your request and respond within 5–7 business days. Approved refunds
                will be processed within 7–14 business days.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">4. Non-Refundable Items</h2>
              <p>The following are not eligible for refunds:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Completed one-time consultations where the service was fully delivered</li>
                <li>Digital downloads or resources that have already been accessed</li>
                <li>Purchases made outside the stated guarantee window</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">5. Amendments</h2>
              <p>
                We reserve the right to modify this Refund Policy at any time. Any changes will be posted
                on this page with an updated date. We encourage you to review this policy periodically.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">6. Contact Us</h2>
              <p>
                For any questions about our Refund Policy or to submit a refund request, please contact us:
              </p>
              {contactBlock}
            </section>

          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default RefundPolicy;